import { render, staticRenderFns } from "./dialogScan.vue?vue&type=template&id=983e4f0c&scoped=true"
import script from "./dialogScan.vue?vue&type=script&lang=js"
export * from "./dialogScan.vue?vue&type=script&lang=js"
import style0 from "./dialogScan.vue?vue&type=style&index=0&id=983e4f0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983e4f0c",
  null
  
)

export default component.exports